/**
 * Shared by PushUserFilterBar and PushUserRow so headers and cells stay one grid.
 * The checkbox column is 44px because ListItem pads its first cell 15px and the tick mark is
 * 22px — anything narrower pushes the circle into the card's 30px corner radius.
 */
export const pushUserColumns = "44px 2fr 1.4fr 1fr";

export const PAGE_LIMIT = 20;
